/**
 * Groups games by calendar date, returning sections for React Native SectionList.
 */

import { format, parseISO } from 'date-fns';
import type { GameResult } from '../types/gameResults.types';
import { LEAGUE_DATE_HEADER_FORMAT } from '../constants/gameResults.constants';

export interface DateSection {
  title: string;
  dateKey: string;
  data: GameResult[];
}

function dateOnly(isoDate: string): string {
  return isoDate.slice(0, 10);
}

/**
 * Group games by YYYY-MM-DD, sorted ascending. Each section has a formatted title
 * (e.g. "Saturday, 9 Mar") and the games for that day sorted by kickoff time.
 */
export function groupGamesByDate(games: GameResult[]): DateSection[] {
  const byDate = new Map<string, GameResult[]>();

  for (const game of games) {
    const key = dateOnly(game.date);
    const list = byDate.get(key) ?? [];
    list.push(game);
    byDate.set(key, list);
  }

  return Array.from(byDate.entries())
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([dateKey, data]) => ({
      title: format(parseISO(dateKey), LEAGUE_DATE_HEADER_FORMAT),
      dateKey,
      data: data.sort(
        (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime()
      ),
    }));
}
